import React from 'react';

import {ForecastQueryRenderer} from '../../../../../../../ForecastQueryRenderer';
import {RelayProps} from '../../../../../../../relay-helpers/TSRelayConverter';
import TimeRegistrationModalTimer, {TimeRegistrationModalTimerQuery} from '../TimeRegistrationModalTimer';

import type {TimeRegistrationModalTimerBaseProps} from '../TimeRegistrationModalTimer';
import type {TimeRegistrationModalTimer_viewer$data as TimeRegistrationModalTimer_viewer} from '../__generated__/TimeRegistrationModalTimer_viewer.graphql';

function TimeRegistrationModalTimerQueryWrapper({...modalProps}: TimeRegistrationModalTimerBaseProps): JSX.Element {
	return (
		<ForecastQueryRenderer
			key="query-render-time_reg_modal_timer"
			query={TimeRegistrationModalTimerQuery}
			fetchPolicy={'network-only'}
			modal={true}
			render={(relayProps: RelayProps<TimeRegistrationModalTimer_viewer>) => {
				return <TimeRegistrationModalTimer {...relayProps} {...modalProps} />;
			}}
		/>
	);
}

export default TimeRegistrationModalTimerQueryWrapper;
